// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { GetIntegrationJdCallbackQuery, BaseResponseVoid } from '../../../types';

/**
 * 商家授权回调
 *
 * @export
 * @tags integration-config-controller
 * @link [GET] /integration/jd/callback
 */
export function getIntegrationJdCallback(
    options: ApiOptions<never, GetIntegrationJdCallbackQuery> & {
        params: GetIntegrationJdCallbackQuery;
    }
): Promise<BaseResponseVoid> {
    return request<never, never, GetIntegrationJdCallbackQuery>('/integration/jd/callback', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getIntegrationJdCallback',
    });
}

export const meta = [
    { tags: ['integration-config-controller'], path: '/integration/jd/callback', method: 'get' },
];
